var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.traverseTimeShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          { staticClass: "content", attrs: { id: "traverseTimeRealTime" } },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n              " +
                  _vm._s(_vm.$t("language.cloudSync.timeOut")) +
                  "\n               "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    _vm.traverseTimeShow = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "traverseTime-body" }, [
              _c("div", { staticClass: "traverseTime-info" }, [
                _vm._v(
                  "\n                      " +
                    _vm._s(_vm.$t("language.cloudSync.outMostly")) +
                    "\n                 "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "realtime-traverseTime-bottom" }, [
                _c(
                  "button",
                  {
                    staticStyle: { width: "110Px", float: "right" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.sureTasK()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("language.common.ok")))]
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b630893", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b630893","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/travese_time_popup.vue
// module id = null
// module chunks = 